import Box from "@mui/material/Box";
import { CustomLinearProgress } from "../components/ProgressComponents/CustomLinearProgress";
import { notFoundPageStyles } from "./styles";

const Loading: React.FC = () => {
  return (
    <Box sx={notFoundPageStyles.loadingBox}>
      <img src="/assets/images/logo-icon.png" alt="logo" width={150} />
      <Box sx={{ width: "60%", mt: 4 }}>
        <CustomLinearProgress sx={{ backgroundColor: "blue" }} />
      </Box>
    </Box>
  );
};

export default Loading;
